export default __webpack_public_path__ + "static/media/female.0d9a3b68.svg";